import React, { Component } from "react";
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
const numberWithCommas_display = require('../service/excelService.js').numberWithCommas_display;


class ExportPDF extends Component {


    constructor(props) {
        super(props);
        this.state = {
            dataSet: [],
            type: '',

            documentDefinition: {
                pageSize: 'A4',
                pageOrientation: 'landscape',
                content: [],
                dontBreakRows: true,
                pageMargins: [30, 50, 30, 50],
                defaultStyle: {
                    fontSize: 10
                },
                startPosition: {
                    horizontalRatio: 0.2
                }
            }
        }

    }

    componentDidMount() {
        this.setState({ dataSet: this.props.data }, () => {
            this._exportPdfTable();
        });
    }

    componentWillUnmount() {
        this._exportPdfTable();
    }

    renderColRow(columns) {

        var row = []

        for (var j = 0; j < columns.length; j++) {

            var col = columns[j].name;
            row.push({ text: col, alignment: "left" })

        }
        return row;
    }


    renderTableData(columns, table_data) {

        var rows = []
        var columnRow = this.renderColRow(columns);
        rows.push(columnRow);

        if (table_data && table_data.length) {

            for (var i = 0; i < table_data.length; i++) {

                var batch = table_data[i];

                var row = []
                row.push({ text: batch['Description'], alignment: "left" })
                row.push({ text: batch['BatchID'], alignment: "left" })
                row.push({ text: batch['TransactionDate'], alignment: "left" })

                if (batch['CHEQUE'])
                    row.push({ text: '$' + numberWithCommas_display(batch['CHEQUE']), alignment: "left" })
                else
                    row.push({ text: '' })
                
                if (batch['CHQ_SPLIT'])
                    row.push({ text: '$' + numberWithCommas_display(batch['CHQ_SPLIT']), alignment: "left" })
                else
                    row.push({ text: '' })

                if (batch['CASH'])
                    row.push({ text: '$' + numberWithCommas_display(batch['CASH']), alignment: "left" })
                else
                    row.push({ text: '' })

                if (batch['GIRO'])
                    row.push({ text: '$' + numberWithCommas_display(batch['GIRO']), alignment: "left" })
                else
                    row.push({ text: '' })

                if (batch['BANK_TRANS'])
                    row.push({ text: '$' + numberWithCommas_display(batch['BANK_TRANS']), alignment: "left" })
                else
                    row.push({ text: '' })

                if (batch['CREDITCARD'])
                    row.push({ text: '$' + numberWithCommas_display(batch['CREDITCARD']), alignment: "left" })
                else
                    row.push({ text: '' })

                if (batch['CC_SPLIT'])
                    row.push({ text: '$' + numberWithCommas_display(batch['CC_SPLIT']), alignment: "left" })
                else
                    row.push({ text: '' })
                
                if (batch['CC_COVER'])
                    row.push({ text: '$' + numberWithCommas_display(batch['CC_COVER']), alignment: "left" })
                else
                    row.push({ text: '' })

                if (batch['BatchTotal'])
                    row.push({ text: '$' + numberWithCommas_display(batch['BatchTotal']), alignment: "right" })
                else
                    row.push({ text: '' })

                rows.push(row);
            }
            return rows;
        }
        return rows;
    }

    _exportPdfTable = () => {
        const { dataSet } = this.state;

        const title = {
            text: dataSet.title,
            alignment: 'center',
            bold: true, fontSize: 16
        }

        const table_data = dataSet.data;
        const columns = dataSet.columns;

        var body = this.renderTableData(columns, table_data);

        var income = {
            table: {
                headerRows: 1,
                body: body
            },
            layout: 'lightHorizontalLines'
        }

        var content = [title, income];
        // console.log('content', content)
        this.setState({ documentDefinition: { ...this.state.documentDefinition, content: content } });
    }

    onClick = () => {
        var documentDefinition = this.state.documentDefinition;
        const { vfs } = vfsFonts.pdfMake;
        pdfMake.vfs = vfs;
        return pdfMake.createPdf(documentDefinition).open();
    }

    render() {
        return (<button type="button" className='btn btn-primary' onClick={this.onClick.bind()}>Download PDF</button>)
    }

}


export default ExportPDF;